module.exports = __webpack_public_path__ + "static/media/guitarneckhowto.d25fa6d9.png";